if (process.env.NODE_ENV !== 'development') {
  const revision = process.env.REVISION;

  window.CASCOON_REVISION = window.CASCOON_REVISION || {};
  // eslint-disable-next-line no-underscore-dangle, no-undef
  window.CASCOON_REVISION[revision.date] = { ...revision, bundleHash: __webpack_hash__ };
}
